// import showdown from 'showdown';
import Viewer from '@toast-ui/editor/dist/toastui-editor-viewer';
/**
 * Convert Markdown language to html string
 *
 * @param markdown
 * @returns
 */
export const convertMDToHTML = (markdown: string): string => {
  // const converter = new showdown.Converter({
  //   strikethrough: true, emoji: true, openLinksInNewWindow: true, parseImgDimensions: true,
  //   requireSpaceBeforeHeadingText: true, tables: true, tasklists: true, underline: true
  // });
  // return converter.makeHtml(markdown);
    try {

        if (!markdown) return ''
        const el = document.createElement('div')
        const viewer = new Viewer({
            el,
            viewer: true,
            linkAttributes: {
                target: '_blank',

            },
            initialValue: markdown.replaceAll('\\n',"\n").replaceAll('\\t',"\t")
        })

        return el.innerHTML
    }catch(error){
        console.log("MARKDOWN PARSE ERROR", error.message, error.toString())
    }
    return ''
};
